const membersPopoverContent = (project, type) => {
  if (
    !project ||
    !project.projectMembers ||
    !project.projectMembers.length ||
    !type
  ) {
    return '';
  }

  let members = project.projectMembers.filter(member => {
    return member.type === type;
  });

  if (!members || !members.length) {
    return '';
  }

  if (type === 'Team') {
    type = 'Key Stakeholder';
  }

  if (type === 'Owner') {
    type = 'Project Owner';
  }

  if (type === 'Other') {
    type = 'Other Stakeholder';
  }

  if (members.length > 1) {
    type += 's';
  }

  let html = `<div class="large"><h6><span>${type}</span></h6>`;

  members.forEach(member => {
    html += `<p>${member.name}</p>`;
  });

  html += `</div>`;

  return html;
};

export default membersPopoverContent;
